// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 전체 앱 스타일 */
.App {
  font-family: 'Arial', sans-serif;
  background-color: #f0f2f5;
  min-height: 100vh;
}

/* 메인 콘텐츠 레이아웃 */
.main-content {
  min-height: 100vh;
  padding: 20px;
}

/* 헤더 스타일 */
.App-header {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.App-header h1 {
  color: #333;
  margin: 0;
  font-size: 24px;
}

/* 전체 레이아웃 */
.App-columns {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.App-column {
  flex: 1 1;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: calc(95vh - 180px);
  overflow-y: auto;
  position: relative;
  /* display: grid; */
}

/* 결과 컨테이너 스타일 */

.result-section {
  margin-bottom: 15px;
}

.result-section h5 {
  color: #495057;
  margin-bottom: 5px;
}

.result-section p {
  color: #212529;
  line-height: 1.6;
}

.column-content{
}

/* 드롭다운 스타일 */
.persona-dropdown {
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background-color: white;
  font-size: 16px;
  color: #495057;
}

/* 버튼 스타일 */
button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

button:hover {
  background-color: #0056b3;
}

button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

/* 로딩 모달 스타일 */
.loading-modal {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.loading-gif {
  width: 80px;
  height: 80px;
}

/* 에러 메시지 스타일 */
.error-message {
  background-color: #f8d7da;
  color: #721c24;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 20px;
}

/* 이미지 갤러리 스타일 */
.image-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 15px;
  margin-top: 15px;
}

.gallery-image {
  width: 100%;
  height: auto;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.gallery-image:hover {
  transform: scale(1.05);
}

/* 모달 스타일 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.modal-image {
  max-height: 80vh;
  max-width: 90vw;
  object-fit: contain;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,gCAAgC;EAChC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,gBAAgB;;AAEhB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;AACA;;AAEA,aAAa;AACb;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/* 전체 앱 스타일 */\n.App {\n  font-family: 'Arial', sans-serif;\n  background-color: #f0f2f5;\n  min-height: 100vh;\n}\n\n/* 메인 콘텐츠 레이아웃 */\n.main-content {\n  min-height: 100vh;\n  padding: 20px;\n}\n\n/* 헤더 스타일 */\n.App-header {\n  background-color: #ffffff;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n}\n\n.App-header h1 {\n  color: #333;\n  margin: 0;\n  font-size: 24px;\n}\n\n/* 전체 레이아웃 */\n.App-columns {\n  display: flex;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.App-column {\n  flex: 1;\n  background-color: #ffffff;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  height: calc(95vh - 180px);\n  overflow-y: auto;\n  position: relative;\n  /* display: grid; */\n}\n\n/* 결과 컨테이너 스타일 */\n\n.result-section {\n  margin-bottom: 15px;\n}\n\n.result-section h5 {\n  color: #495057;\n  margin-bottom: 5px;\n}\n\n.result-section p {\n  color: #212529;\n  line-height: 1.6;\n}\n\n.column-content{\n}\n\n/* 드롭다운 스타일 */\n.persona-dropdown {\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 15px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  background-color: white;\n  font-size: 16px;\n  color: #495057;\n}\n\n/* 버튼 스타일 */\nbutton {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background-color 0.3s;\n}\n\nbutton:hover {\n  background-color: #0056b3;\n}\n\nbutton:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n}\n\n/* 로딩 모달 스타일 */\n.loading-modal {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.loading-gif {\n  width: 80px;\n  height: 80px;\n}\n\n/* 에러 메시지 스타일 */\n.error-message {\n  background-color: #f8d7da;\n  color: #721c24;\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n/* 이미지 갤러리 스타일 */\n.image-gallery {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: 15px;\n  margin-top: 15px;\n}\n\n.gallery-image {\n  width: 100%;\n  height: auto;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n\n.gallery-image:hover {\n  transform: scale(1.05);\n}\n\n/* 모달 스타일 */\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n}\n\n.modal-image {\n  max-height: 80vh;\n  max-width: 90vw;\n  object-fit: contain;\n  border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
